import type { KlientStatus } from '../api/klienti';
import type { MailingSpace } from '../api/mailing';

export type KlientTabId = 'prehledy' | 'udaje' | 'dealy' | 'kontakty' | 'poznamky' | 'mesice' | 'affiliates' | 'doklady' | 'dokumenty' | 'vystupy' | 'helpdesk';

export interface KlientTabDef {
  id: KlientTabId;
  label: string;
  description: string;
}

export interface KlientiSpaceConfig {
  slug: string;
  eyebrow: string;
  entityEyebrow: string;
  title: string;
  description: string;
  permissionModule: string;
  billing?: { fixProduct: string };
  mailingSpace: MailingSpace | null;
  tabs: KlientTabDef[];
  dealCurrency: 'CZK' | 'EUR';
  products: string[];
  modules: string[];
  focuses: string[];
  markets: Array<{ code: string; label: string }>;
}

export const KLIENT_STATUS_DEF: Record<KlientStatus, { label: string; className: string }> = {
  active: { label: 'Aktivní', className: 'is-active' },
  paused: { label: 'Pozastavený', className: 'is-paused' },
  ended: { label: 'Ukončený', className: 'is-ended' },
};

export const KLIENT_STATUSES: KlientStatus[] = ['active', 'paused', 'ended'];

const AFFILPLATFORM: KlientiSpaceConfig = {
  slug: 'affilplatform',
  eyebrow: 'AFFILPLATFORM',
  entityEyebrow: 'KLIENT',
  title: 'Klienti',
  description: 'Přehled klientů Affilplatformu, jejich tarifů a kontaktů',
  permissionModule: 'klienti',
  mailingSpace: 'affilplatform',
  tabs: [
    { id: 'prehledy', label: 'Přehledy', description: 'Souhrn klienta a jeho výkonu' },
    { id: 'udaje', label: 'Údaje', description: 'Identifikační, produktové a smluvní údaje klienta' },
    { id: 'dealy', label: 'Dealy', description: 'Fixní položky a provize k fakturaci' },
    { id: 'kontakty', label: 'Kontakty', description: 'Kontaktní osoby klienta' },
    { id: 'poznamky', label: 'Poznámky', description: 'Podmínky spolupráce, dohody a kontext' },
    { id: 'mesice', label: 'Měsíční rozpad', description: 'Výkon klienta po jednotlivých měsících' },
    { id: 'affiliates', label: 'Affiliates', description: 'Affiliate partneři přivádějící výkon klientovi' },
    { id: 'doklady', label: 'Doklady', description: 'Vydané doklady klienta' },
    { id: 'dokumenty', label: 'Dokumenty', description: 'Nabídky, smlouvy a podklady klienta na Google Drive' },
    { id: 'vystupy', label: 'Výstupy', description: 'Nabídky, reporty a návody klienta sdílené odkazem' },
    { id: 'helpdesk', label: 'Helpdesk', description: 'Tickety kontaktních osob klienta' },
  ],
  dealCurrency: 'EUR',
  products: ['iGaming Affiliate', 'Land Based Affiliate', 'Obojí'],
  modules: ['Standard', 'Pro', 'Pro + Multibrand', 'Pro + AI', 'Pro Full'],
  focuses: ['Online casino / sportsbet', 'Land-based casino', 'Obojí', 'Network', 'Jiné'],
  markets: [
    { code: 'CZ', label: 'Česko' },
    { code: 'SK', label: 'Slovensko' },
    { code: 'Global', label: 'Global' },
  ],
};

const DMWK: KlientiSpaceConfig = {
  slug: 'dmwk',
  eyebrow: 'DMWK',
  entityEyebrow: 'KLIENT',
  title: 'Klienti',
  description: 'Klienti DMWK, jejich fakturační údaje a měsíční dealy',
  permissionModule: 'klienti',
  mailingSpace: null,
  dealCurrency: 'CZK',
  billing: { fixProduct: 'ostatni_sluzby' },
  tabs: [
    { id: 'udaje', label: 'Údaje', description: 'Identifikační a fakturační údaje klienta' },
    { id: 'dealy', label: 'Dealy', description: 'Měsíční fixní položky k fakturaci' },
    { id: 'kontakty', label: 'Kontakty', description: 'Kontaktní osoby klienta' },
    { id: 'poznamky', label: 'Poznámky', description: 'Podmínky spolupráce, dohody a kontext' },
  ],
  products: [],
  modules: [],
  focuses: [],
  markets: [
    { code: 'CZ', label: 'Česko' },
    { code: 'SK', label: 'Slovensko' },
  ],
};

const CONFIGS: Record<string, KlientiSpaceConfig> = {
  affilplatform: AFFILPLATFORM,
  dmwk: DMWK,
};

export function klientiConfigFor(slug: string): KlientiSpaceConfig {
  const cfg = CONFIGS[slug];
  if (!cfg) throw new Error(`Modul Klienti není pro Space „${slug}" nakonfigurovaný.`);
  return cfg;
}

export function klientTabIds(cfg: KlientiSpaceConfig): KlientTabId[] {
  return cfg.tabs.map((t) => t.id);
}
